(function () {
  var STORAGE_KEY = 'dune_attribution_v1';
  var SYNC_KEY = 'dune_attribution_cart_sync_v1';
  var MAX_VALUE_LENGTH = 900;

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function analyticsAllowed() {
    var privacy = customerPrivacy();
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
      return false;
    }

    try {
      return privacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function readStored() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      // Storage can be unavailable in private browsers; silently skip.
    }
  }

  function clean(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().slice(0, MAX_VALUE_LENGTH);
  }

  function param(params, name) {
    return clean(params.get(name));
  }

  function hasAny(values) {
    return Object.keys(values).some(function (key) {
      return values[key] !== '';
    });
  }

  function hostFromUrl(value) {
    if (!value) return '';
    try {
      return new URL(value).hostname.replace(/^www\./, '').toLowerCase();
    } catch (error) {
      return '';
    }
  }

  function classify(touch) {
    var source = (touch.utm_source || touch.source || '').toLowerCase();
    var medium = (touch.utm_medium || '').toLowerCase();
    var referrerHost = hostFromUrl(touch.referrer);
    var combined = [source, medium, referrerHost].join(' ');

    if (touch.gclid || touch.fbclid || touch.msclkid || touch.ttclid) {
      return 'paid_ads';
    }

    if (/(cpc|ppc|paid|ads?|display|retargeting|shopping|paid_social)/.test(medium)) {
      return 'paid_ads';
    }

    if (/(email|newsletter|klaviyo|mailchimp)/.test(combined)) {
      return 'email';
    }

    if (/(instagram|facebook|fb\\.com|pinterest|tiktok|youtube|linkedin|threads|social)/.test(combined)) {
      return 'social';
    }

    if (/(google|bing|duckduckgo|yahoo|yandex|ecosia|baidu)/.test(combined) || medium === 'organic') {
      return 'search';
    }

    if (!touch.referrer && !hasAny({
      source: source,
      medium: medium,
      gclid: touch.gclid,
      fbclid: touch.fbclid,
      msclkid: touch.msclkid,
      ttclid: touch.ttclid
    })) {
      return 'direct';
    }

    if (touch.referrer || source || medium) {
      return 'unknown';
    }

    return 'unknown';
  }

  function currentTouch() {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var touch = {
      captured_at: new Date().toISOString(),
      landing_page: clean(window.location.href.split('#')[0]),
      page_path: clean(window.location.pathname),
      referrer: clean(document.referrer),
      referrer_host: clean(hostFromUrl(document.referrer)),
      utm_source: param(params, 'utm_source'),
      utm_medium: param(params, 'utm_medium'),
      utm_campaign: param(params, 'utm_campaign'),
      utm_content: param(params, 'utm_content'),
      utm_term: param(params, 'utm_term'),
      referral_code: param(params, 'ref') || param(params, 'source') || param(params, 'r'),
      gclid: param(params, 'gclid'),
      fbclid: param(params, 'fbclid'),
      msclkid: param(params, 'msclkid'),
      ttclid: param(params, 'ttclid')
    };

    touch.source = touch.utm_source || touch.referrer_host || (touch.referral_code ? 'referral' : 'direct');
    touch.source_category = classify(touch);
    return touch;
  }

  function buildAttributes(data) {
    var first = data.first || {};
    var last = data.last || {};
    var attrs = {
      'Attribution first captured at': first.captured_at,
      'Attribution first source category': first.source_category,
      'Attribution first source': first.source,
      'Attribution first landing page': first.landing_page,
      'Attribution first referrer': first.referrer,
      'Attribution first referrer host': first.referrer_host,
      'Attribution first utm_source': first.utm_source,
      'Attribution first utm_medium': first.utm_medium,
      'Attribution first utm_campaign': first.utm_campaign,
      'Attribution first utm_content': first.utm_content,
      'Attribution first utm_term': first.utm_term,
      'Attribution first referral code': first.referral_code,
      'Attribution first click id': first.gclid || first.fbclid || first.msclkid || first.ttclid,
      'Attribution last captured at': last.captured_at,
      'Attribution last source category': last.source_category,
      'Attribution last source': last.source,
      'Attribution last landing page': last.landing_page,
      'Attribution last referrer': last.referrer,
      'Attribution last referrer host': last.referrer_host,
      'Attribution last utm_source': last.utm_source,
      'Attribution last utm_medium': last.utm_medium,
      'Attribution last utm_campaign': last.utm_campaign,
      'Attribution last utm_content': last.utm_content,
      'Attribution last utm_term': last.utm_term,
      'Attribution last referral code': last.referral_code,
      'Attribution last click id': last.gclid || last.fbclid || last.msclkid || last.ttclid
    };

    Object.keys(attrs).forEach(function (key) {
      attrs[key] = clean(attrs[key]);
    });

    return attrs;
  }

  function syncCart(attributes) {
    var signature = JSON.stringify(attributes);

    try {
      if (window.sessionStorage.getItem(SYNC_KEY) === signature) return;
      window.sessionStorage.setItem(SYNC_KEY, signature);
    } catch (error) {
      // Session storage is an optimization only.
    }

    window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).catch(function () {});
  }

  function capture() {
    if (!analyticsAllowed()) return;

    var stored = readStored();
    var touch = currentTouch();
    var data = {
      first: stored.first || touch,
      last: touch
    };

    writeStored(data);
    syncCart(buildAttributes(data));
  }

  function scheduleCapture() {
    window.setTimeout(capture, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCapture);
  } else {
    scheduleCapture();
  }

  document.addEventListener('visitorConsentCollected', scheduleCapture);

  window.DuneAttribution = {
    capture: capture,
    currentTouch: currentTouch
  };
})();
